"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_scss_1 = __importDefault(require("../styles.scss"));
const CloseIcon = () => {
    return (react_1.default.createElement("div", { "data-component-name": "CloseIcon", role: "img", className: styles_scss_1.default['delete-button__close-icon'], "aria-hidden": "true" }));
};
exports.default = CloseIcon;
